import { useSidebarManager } from 'contexts/SidebarManagerContext';
import React from 'react';
import IndexChat from './IndexChat';
import { Message } from '../types/types';
interface MessageNotificationProps {
  userId: string;
  message: Message;
}
const MessageNotification: React.FC<MessageNotificationProps> = ({
  userId,
  message,
}) => {
  const { openSidebar } = useSidebarManager();

  return (
    <>
      <div
        onClick={() => {
          openSidebar(IndexChat, true, { userId: userId, isGroup: false });
        }}
        className="tw-flex tw-items-center"
      >
        <div className="tw-flex tw-items-center">
          <img
            className="tw-w-10 tw-h-10 tw-rounded-full tw-object-cover"
            src={`/upload/profileimages/${message.user}/${message.image}`}
            alt=""
          />
          <div className="tw-flex tw-flex-col tw-ms-2">
            <h6 className="tw-leading-none tw-mb-1 tw-text-sm tw-font-medium">
              {message.userFullName}
            </h6>
            <h6 className="tw-text-dark-gray3 tw-leading-none tw-text-xs">
              {message.message ?? message.files[message.files.length - 1]?.name}
            </h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageNotification;
